import React from 'react';
import { Alert } from '@material-ui/lab';
import { StatusCodeKey } from '../../../domain/constants/StatusCode';

const statusKey = (id) => {
  const typeError = {
    [StatusCodeKey.inventario]: 'info',
    [StatusCodeKey.prestada]: 'warning',
    [StatusCodeKey.bajaExtravio]: 'error',
  };
  return typeError[id] ?? 'error';
};

const StatusKey = ({ id, str }) => (
  <Alert
    className='!text-black !rounded-lg'
    severity={statusKey(id)}
    icon={false}
  >
    {str}
  </Alert>
);

export default StatusKey;
